// check the value of the token
// if expiry date is getting nearer, then show the timerID.

import React from "react";
import { AppContext } from "../context/AppContext";
import { Dialog } from "@progress/kendo-react-dialogs";
import { DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { Redirect } from 'react-router-dom';
import isPage from '../hoc/isPage';
import { getMinutesInMilliseconds } from '../helpers';

class TokenHelper extends React.Component {
    timerID;
    expiryDate;
    //fiveMinutes = 5 * 60 * 1000;

    //interval = 2000; // how often we want to check the token validity in milliseconds
    interval = 60000; // how often we want to check the token validity in milliseconds

    //minutesTillNotification = 120; // how many minutes before token expiry do we want to notify the user
    minutesTillNotification = 5; // how many minutes before token expiry do we want to notify the user

    state = {
        showModal: false,
        logout: false,
        timeout: false // too late, session has expired
    };

    checkToken = () => {

        this.expiryDate = new Date(this.context.state.expiresAt);

        let millisecondsTillSessionExpires = this.expiryDate - new Date();

        if (millisecondsTillSessionExpires < 0) {

            this.setState({ showModal: false, timeout: true, logout: true });

        } else if (millisecondsTillSessionExpires < getMinutesInMilliseconds(this.minutesTillNotification)) {

            this.setState({ showModal: true });
        }
    };

    componentWillUnmount() {
        window.clearInterval(this.timerID);
    }

    componentDidMount() {

        // check expiry every minute
        this.timerID = window.setInterval(this.checkToken, this.interval);
    }

    handleEndSession = () => {

        //this.context.logout();
        this.setState({ showModal: false, logout: true });
    };

    handleRenewSession = () => {


        this.context.auth.renewSession();
        this.setState({ showModal: false });
    };

    handleCloseModal = () => {
        this.props.alert("info", this.props.returnLocalizedString("m0497"), this.props.returnLocalizedString("m0498"));
    };

    render() {

        if (this.state.logout) {
            //this.context.logout();

            return (
                <Redirect to="/?s=logout" />
            );
        }

        //!DBTRANS! @m0497@ Modal can't be closed. !DEVNOTE! Info message
        //!DBTRANS! @m0498@ You have to choose one of the options below. !DEVNOTE! Info message
        //!DBTRANS! @m0499@ Your session is about to expire in under 5 minutes. !DEVNOTE! Info message
        //!DBTRANS! @m0500@ Do you want to continue using this application? !DEVNOTE! Info message
        //!DBTRANS! @m0501@ End my session !DEVNOTE! Button label
        //!DBTRANS! @m0502@ Continue session !DEVNOTE! Button label

        return (
            <React.Fragment>
                {this.state.showModal && <Dialog className="confirmation"

                    width={480}
                    height='auto'
                    minWidth={320}
                    closeIcon={false}
                    title={"Session Expiring"}
                    onClose={this.handleCloseModal}
                >
                    <p>{this.props.returnLocalizedString("m0499")}</p>
                    <p>{this.props.returnLocalizedString("m0500")}</p>

                    <DialogActionsBar>
                        <Button
                            className="cancel" 
                            onClick={this.handleEndSession}
                        >
                            {this.props.returnLocalizedString("m0501")}
					</Button>
                        <Button className="yes" primary={true} 
                            onClick={this.handleRenewSession}
                        >
                            {this.props.returnLocalizedString("m0502")}
					</Button>
                    </DialogActionsBar>
                </Dialog>
                }
            </React.Fragment>
        );
    }
}

TokenHelper.contextType = AppContext;
export default isPage(TokenHelper);



// WEBPACK FOOTER //
// ./src/components/TokenHelper.js